const getSlope = (a, b) =>
  (a.y - b.y) / (a.x - b.x);

export default getSlope;